import script from "./IotServerApiDoc.vue?vue&type=script&setup=true&lang=js"
export * from "./IotServerApiDoc.vue?vue&type=script&setup=true&lang=js"

import "./IotServerApiDoc.vue?vue&type=style&index=0&id=3853bcd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3853bcd0"]])

export default __exports__